import { Action, combineReducers } from '@ngrx/store';
import { objDiff } from '../utility';

import {
  _CLEAR,
  CREATE_LASER_PRESTA_MATERIAL_CONFIG,
  CREATE_SETTING,
  DELETE_LASER_PRESTA_MATERIAL_CONFIG,
  DELETE_SETTING,
  GET_LASER_PRESTA_MATERIAL_CONFIG,
  GET_NEXT_BUSINESS_DAY,
  GET_SETTINGS,
  SET_SETTING_LIST_VIEW,
  UPDATE_LASER_PRESTA_MATERIAL_CONFIG,
  UPDATE_SETTING
} from '../actions';
import { Observable } from 'rxjs/Observable';

const systemSettingListViewState = {
  loading: <boolean>false
};

export function nextBusinessDayReducer(state = null, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return null;
    case GET_NEXT_BUSINESS_DAY:
      return action.payload.nextBusinessDay;
    default:
      return state;
  }
}

export function systemSettingListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_SETTING:
      const match = state.find(setting => action.payload.setting && setting.id === action.payload.setting.id);
      return !match
        ? [ ...state, action.payload.setting ]
        : state;
    case DELETE_SETTING:
      return state.filter(setting => setting.id !== action.payload.id);
    case GET_SETTINGS:
      return [ ...action.payload.settings ];
    case UPDATE_SETTING:
      return state.map(setting => {
        return setting.id === action.payload.id
          ? objDiff(setting, action.payload.diffList)
          : setting;
      });
    default:
      return state;
  }
}

export function systemSettingListViewReducer(state = systemSettingListViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return systemSettingListViewState;
    case SET_SETTING_LIST_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export function laserPrestaMaterialConfigReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_LASER_PRESTA_MATERIAL_CONFIG:
      // return [...state, action.payload.prestaSubassemblyConfig].sort(sortPrestaSubassemblyConfigs);
      return [...state, action.payload.prestaSubassemblyConfig]
    case DELETE_LASER_PRESTA_MATERIAL_CONFIG:
      return state.filter(laserPrestaMaterialConfig => laserPrestaMaterialConfig.id !== action.payload.id);
    case GET_LASER_PRESTA_MATERIAL_CONFIG:
      return action.payload.listPrestaSubassemblyConfigs;
    case UPDATE_LASER_PRESTA_MATERIAL_CONFIG:
      return state.map(laserPrestaMaterialConfig => {
        return laserPrestaMaterialConfig.id === action.payload.id
          ? objDiff(laserPrestaMaterialConfig, action.payload.diffList)
          : laserPrestaMaterialConfig;
      });
    default:
      return state;
  }
}

export function getLaserPrestaMaterialConfigList(): Observable<any> {
  return this.store.select('settings', 'laserPrestaMaterialConfigs');
}

const sortPrestaSubassemblyConfigs = (a, b) => {
  return +a.presta.replace('-', '') - +b.presta.replace('-', '');
};

export const settingReducers = combineReducers({
  nextBusinessDay: nextBusinessDayReducer,
  systemSettingList: systemSettingListReducer,
  systemSettingListView: systemSettingListViewReducer,
  laserPrestaMaterialConfigs: laserPrestaMaterialConfigReducer
});



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/settings.ts